module.exports = __webpack_public_path__ + "static/media/periodic-inspection.552a3fd7.svg";